var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 5.329v6.19c0 .091-.032.169-.096.232a.317.317 0 0 1-.233.096h-6.19c-.152 0-.256-.066-.312-.199-.036-.158-.01-.277.076-.359l1.918-1.903c-.835-.748-1.831-1.123-2.988-1.123-.616 0-1.206.121-1.769.363a4.606 4.606 0 0 0-1.455.974 4.606 4.606 0 0 0-.975 1.456 4.433 4.433 0 0 0-.363 1.769c0 .616.121 1.206.363 1.769s.567 1.048.975 1.455c.407.408.892.733 1.455.975a4.433 4.433 0 0 0 1.77.363c1.12 0 2.121-.375 3.002-1.124a.309.309 0 0 1 .226-.087.299.299 0 0 1 .21.087l1.398 1.399v.015c.061.046.092.12.092.222 0 .081-.03.152-.092.214 0 .015-.005.023-.015.023a7.24 7.24 0 0 1-2.216 1.371 7.018 7.018 0 0 1-2.606.493c-.968 0-1.895-.19-2.781-.57A7.223 7.223 0 0 1 7.1 17.9a7.223 7.223 0 0 1-1.532-2.293A6.995 6.995 0 0 1 5 12.825c0-.968.19-1.895.57-2.781.379-.887.89-1.651 1.531-2.293A7.223 7.223 0 0 1 9.394 6.22a6.995 6.995 0 0 1 2.781-.57c.917 0 1.79.165 2.617.494a7.125 7.125 0 0 1 2.22 1.394l2.43-2.445c.082-.087.201-.112.36-.076.132.056.198.16.198.313z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.adc4e31d334a9fd09acf7d7b57c17d5d.svg";
export { ForwardRef as ReactComponent };